import { FC } from 'react'
import { MaterialRequirementsConfiguration } from '../../../../../../types/api/components/material/material-requirements-configuration'
import { useGetStocksQuery } from '../../../../../../store/api/stocks-api'
import Text from 'antd/es/typography/Text'
import MaterialType from '../../../../../../types/api/material-type'

interface CutProps {
    config: MaterialRequirementsConfiguration
    shipmentDocId: string
    materialType: MaterialType
}

const Cut: FC<CutProps> = ({ config, materialType, shipmentDocId }) => {
    const unitShortName = materialType?.unit?.shortName
    // Разрезать - искать сток и смотреть резервацию
    const { data } = useGetStocksQuery(
        {
            filters: {
                material: { documentId: { $eq: config.material?.documentId } },
            },
            populate: {
                stock_reserves: { populate: '*' },
            },
        },
        { refetchOnMountOrArgChange: true }
    )
    const stocks = data?.data || []

    if (stocks.length === 0) return <Text type={'danger'}>Ошибка, нет остатков под резерв</Text>
    if (stocks.length > 1) return <Text type={'danger'}>Ошибка, несколько остатков под резерв</Text>
    const stock = stocks[0]

    const reservedStock = stock.stock_reserves?.find(
        x => x.shipment?.documentId === shipmentDocId && x.amount === config.amount
    )

    if (!reservedStock) {
        return (
            <Text type={'warning'}>
                {config.material?.width} {config.amount} {unitShortName ?? ''} - Будет
                зарезервировано под разрез
            </Text>
        )
    }

    return (
        <div>
            <Text strong>{config.material?.width}</Text> зарезервировано под разрез{' '}
            {reservedStock.amount} {unitShortName}
        </div>
    )
}

export default Cut
